/**
 * @generated SignedSource<<bb63b0b30ce2c50a1a2823511dd2f61c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type walletManageFilesDialog_Query$variables = {
  slug: string;
};
export type walletManageFilesDialog_Query$data = {
  readonly walletFileManifest: {
    readonly files: ReadonlyArray<{
      readonly accountKind: string | null | undefined;
      readonly accountNumber: string | null | undefined;
      readonly duplicate: boolean;
      readonly filename: string | null | undefined;
      readonly firstDate: string | null | undefined;
      readonly lastDate: string | null | undefined;
      readonly notice: string | null | undefined;
      readonly provider: string | null | undefined;
      readonly rows: number;
      readonly uploadedAt: any | null | undefined;
    }>;
    readonly outflowMonths: ReadonlyArray<{
      readonly count: number;
      readonly month: string;
    }>;
  };
};
export type walletManageFilesDialog_Query = {
  response: walletManageFilesDialog_Query$data;
  variables: walletManageFilesDialog_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadedAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rows",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duplicate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountKind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notice",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "walletManageFilesDialog_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WalletFileManifest",
        "kind": "LinkedField",
        "name": "walletFileManifest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletFile",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletMonthCount",
            "kind": "LinkedField",
            "name": "outflowMonths",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "walletManageFilesDialog_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WalletFileManifest",
        "kind": "LinkedField",
        "name": "walletFileManifest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletFile",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WalletMonthCount",
            "kind": "LinkedField",
            "name": "outflowMonths",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "65a5d838cd82e8aa03de6a9280e53fc6",
    "id": null,
    "metadata": {},
    "name": "walletManageFilesDialog_Query",
    "operationKind": "query",
    "text": "query walletManageFilesDialog_Query(\n  $slug: String!\n) {\n  walletFileManifest(slug: $slug) {\n    files {\n      filename\n      uploadedAt\n      rows\n      firstDate\n      lastDate\n      duplicate\n      provider\n      accountNumber\n      accountKind\n      notice\n      id\n    }\n    outflowMonths {\n      month\n      count\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a072ff59c14077107e9efbad76d1ed2";

export default node;
